// David's badge artwork (Oct 2026). Keyed by badge id: <family>-<tier>.
// BADGE_ART is 192px for the grid; BADGE_ART_LARGE is 400px for the achievement dialog.
import doublesBronze from './doubles-bronze.webp';
import doublesSilver from './doubles-silver.webp';
import doublesGold from './doubles-gold.webp';
import doublesDiamond from './doubles-diamond.webp';
import gamesBronze from './games-bronze.webp';
import gamesSilver from './games-silver.webp';
import gamesGold from './games-gold.webp';
import gamesDiamond from './games-diamond.webp';
import streakBronze from './streak-bronze.webp';
import streakSilver from './streak-silver.webp';
import streakGold from './streak-gold.webp';
import streakDiamond from './streak-diamond.webp';
import mvpBronze from './mvp-bronze.webp';
import mvpSilver from './mvp-silver.webp';
import mvpGold from './mvp-gold.webp';
import mvpDiamond from './mvp-diamond.webp';
import servesBronze from './serves-bronze.webp';
import servesSilver from './serves-silver.webp';
import servesGold from './serves-gold.webp';
import servesDiamond from './serves-diamond.webp';
import eventBronze from './event-bronze.webp';
import eventSilver from './event-silver.webp';
import eventGold from './event-gold.webp';
import eventDiamond from './event-diamond.webp';
import lgdoublesBronze from './large/doubles-bronze.webp';
import lgdoublesSilver from './large/doubles-silver.webp';
import lgdoublesGold from './large/doubles-gold.webp';
import lgdoublesDiamond from './large/doubles-diamond.webp';
import lggamesBronze from './large/games-bronze.webp';
import lggamesSilver from './large/games-silver.webp';
import lggamesGold from './large/games-gold.webp';
import lggamesDiamond from './large/games-diamond.webp';
import lgstreakBronze from './large/streak-bronze.webp';
import lgstreakSilver from './large/streak-silver.webp';
import lgstreakGold from './large/streak-gold.webp';
import lgstreakDiamond from './large/streak-diamond.webp';
import lgmvpBronze from './large/mvp-bronze.webp';
import lgmvpSilver from './large/mvp-silver.webp';
import lgmvpGold from './large/mvp-gold.webp';
import lgmvpDiamond from './large/mvp-diamond.webp';
import lgservesBronze from './large/serves-bronze.webp';
import lgservesSilver from './large/serves-silver.webp';
import lgservesGold from './large/serves-gold.webp';
import lgservesDiamond from './large/serves-diamond.webp';
import lgeventBronze from './large/event-bronze.webp';
import lgeventSilver from './large/event-silver.webp';
import lgeventGold from './large/event-gold.webp';
import lgeventDiamond from './large/event-diamond.webp';

const BADGE_ART = {
  'doubles-bronze': doublesBronze, 'doubles-silver': doublesSilver, 'doubles-gold': doublesGold, 'doubles-diamond': doublesDiamond,
  'games-bronze': gamesBronze, 'games-silver': gamesSilver, 'games-gold': gamesGold, 'games-diamond': gamesDiamond,
  'streak-bronze': streakBronze, 'streak-silver': streakSilver, 'streak-gold': streakGold, 'streak-diamond': streakDiamond,
  'mvp-bronze': mvpBronze, 'mvp-silver': mvpSilver, 'mvp-gold': mvpGold, 'mvp-diamond': mvpDiamond,
  'serves-bronze': servesBronze, 'serves-silver': servesSilver, 'serves-gold': servesGold, 'serves-diamond': servesDiamond,
  'event-bronze': eventBronze, 'event-silver': eventSilver, 'event-gold': eventGold, 'event-diamond': eventDiamond,
};

export const BADGE_ART_LARGE = {
  'doubles-bronze': lgdoublesBronze, 'doubles-silver': lgdoublesSilver, 'doubles-gold': lgdoublesGold, 'doubles-diamond': lgdoublesDiamond,
  'games-bronze': lggamesBronze, 'games-silver': lggamesSilver, 'games-gold': lggamesGold, 'games-diamond': lggamesDiamond,
  'streak-bronze': lgstreakBronze, 'streak-silver': lgstreakSilver, 'streak-gold': lgstreakGold, 'streak-diamond': lgstreakDiamond,
  'mvp-bronze': lgmvpBronze, 'mvp-silver': lgmvpSilver, 'mvp-gold': lgmvpGold, 'mvp-diamond': lgmvpDiamond,
  'serves-bronze': lgservesBronze, 'serves-silver': lgservesSilver, 'serves-gold': lgservesGold, 'serves-diamond': lgservesDiamond,
  'event-bronze': lgeventBronze, 'event-silver': lgeventSilver, 'event-gold': lgeventGold, 'event-diamond': lgeventDiamond,
};

export default BADGE_ART;
